import BaseApi from '@/api/BaseApi';
import type { IPaginate } from '@/models/TableSettingsModel';
import type {
    ICreateEditWarehouseRequest,
    IWareHouseItems,
    IWarehouseResponse,
} from '@/models/WarehouseModel';

export default class WarehouseApi extends BaseApi {
	async warehouseList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, search: string | null) {
        let url = `/api/warehouses?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

		return this.get<IPaginate<IWareHouseItems>>({
			url: url,
		});
	};

	async deleteWarehouse (warehouseId: number) {
		return this.delete({
			url: `/api/warehouses/${warehouseId}`,
		});
	};

    async createWarehouse (payload: ICreateEditWarehouseRequest) {
        return this.post<ICreateEditWarehouseRequest, any>({
            url: `/api/warehouses`,
            data: payload,
        });
    };

    async editWarehouse (payload: ICreateEditWarehouseRequest, warehouseId: string | string[]) {
        return this.put<ICreateEditWarehouseRequest, any>({
            url: `/api/warehouses/${warehouseId}`,
            data: payload,
        });
    };

    async warehouseDetails (warehouseId: string | string[]) {
        return this.get<IWarehouseResponse>({
            url: `/api/warehouses/${warehouseId}`,
        });
    };
};
